import { Panel } from 'primereact/panel';
import { AccionistaSocios } from '../AccionistaSocios';
import * as generic from '../../../components/Generico';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';

export const SocAccPj = ({ toast, back, next, id, permss, tipoFrmEmpresa, soloLectura }) => {

  return (
    <>
      <Panel header={generic.renderPanelHeader('A.6', 'INFORMACIÓN DE LOS SOCIOS/ACCIONISTAS/FIDEICOMITENTES/FIDUCIARIOS/BENEFICIARIOS/CONSTITUYENTES', 'pi pi-users')} className="panel-ficha shadow-1 mb-4">
        <div className="p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
          <div className="flex align-items-center gap-2 mb-2">
            <i className="pi pi-info-circle text-blue-600 text-lg"></i>
            <span className="font-bold text-blue-900">Nota Importante</span>
          </div>
          Solo en el caso de que el socio / accionista sea persona jurídica consignar la siguiente información hasta llegar a la persona natural.
        </div>

        <AccionistaSocios toast={toast} tipo={'clientePj'} id={id} permss={permss} tipoFrmEmpresa={tipoFrmEmpresa} soloLectura={soloLectura} />
      </Panel>
      <BottomActionBar onPrev={back} onNext={next} isReadOnly={true} />
    </>
  );
}
